import type { QueryClient } from "@tanstack/react-query";
import { GlobalApi } from "@/openapi/generated";
import { QueryKeys } from "@/lib/types";
import { createOpenApiConfiguration } from "@/lib/utils";
import { resolveEffectiveTenantNumber } from "@/lib/utils/env/effective-tenant";

const DEFAULT_TENANT_ID = resolveEffectiveTenantNumber();

export function contactRecipientsQueryKey(tenantId: number) {
  return [QueryKeys.ContactRecipients, tenantId] as const;
}

export async function prefetchContactRecipients(
  queryClient: QueryClient,
  tenantId: number = DEFAULT_TENANT_ID,
) {
  const service = new GlobalApi(createOpenApiConfiguration());

  await queryClient.prefetchQuery({
    queryKey: contactRecipientsQueryKey(tenantId),
    queryFn: () =>
      service.apiContactRecipientsGet({
        xTenantID: tenantId,
      }),
    staleTime: 5 * 60 * 1000,
  });

  return queryClient;
}
